import { queryClient } from "~Shared/config/reactQueryConfig"
import { CacheEnum } from "../consts"

export const invalidateOposList = () => queryClient.invalidateQueries({ queryKey: [CacheEnum.EXPENSES_OPOS_LIST] })

export const invalidateOposExcludedList = () => queryClient.invalidateQueries({ queryKey: [CacheEnum.EXPENSES_OPOS_EXCLUDED_LIST] })

export const invalidateOposTotals = () => queryClient.invalidateQueries({ queryKey: [CacheEnum.EXPENSES_OPOS_TOTALS] })

export const invalidateAllOposLists = () => Promise.all([invalidateOposList(), invalidateOposExcludedList(), invalidateOposTotals()])
